const calpak = window.calpak

window.dataLayer = window.dataLayer || [];


document.querySelectorAll(".cart__empty-v2 .top-category-item")?.forEach(item => {
    item.addEventListener("click", function (e) {
        const title = item.dataset.title;
        window.dataLayer.push({
            event: "click-empty_cart_collections",
            nav_click_value: `Empty_Cart_Collections_${title.split(' ').join("_")}`
        })
    })
})

// hero section blocks
function heroBlocks(screen) {
    const heroBlocks = document.querySelectorAll(".hero__block");
    const visibleHeroBlocks = heroBlocks.length && Array.from(heroBlocks).filter(item => {
        const style = window.getComputedStyle(item);
        return style.display !== "none";
    });

    if (visibleHeroBlocks.length) {
        const allMediaBlocks = visibleHeroBlocks?.every(item => item.classList.contains('hero__block--media-block'));
        if (allMediaBlocks) {
            visibleHeroBlocks?.forEach((item, i) => {
                item.addEventListener("click", function (e) {
                    window.dataLayer.push({
                        event: "ga4-event",
                        ga4_event_name: `${visibleHeroBlocks.length}-block-text-overlay--${screen}-${i + 1}`
                    });
                })
            })
        } else {
            visibleHeroBlocks?.forEach((item, i) => {
                item.addEventListener("click", function (e) {
                    window.dataLayer.push({
                        event: "ga4-event",
                        ga4_event_name: `${visibleHeroBlocks.length}-block--${screen}-${i + 1}`
                    })
                })
            })
        }
    }
}

// hero section three blocks carousel
function heroCarouselBlocks(selector, screen) {
    selector.length && selector.forEach((block, i) => {
        block.querySelectorAll(".hero-carousel__block-image")?.forEach((item) => {
            item.addEventListener("click", function (e) {
                window.dataLayer.push({
                    event: "ga4-event",
                    ga4_event_name: `hero-carousel-3-block--${screen}-image-${i + 1}`
                })
            })
        })

        block.querySelectorAll(".button")?.forEach((item) => {
            item.addEventListener("click", function (e) {
                window.dataLayer.push({
                    event: "ga4-event",
                    ga4_event_name: `hero-carousel-3-block--${screen}-btn-${i + 1}`
                })
            })
        })

        block.querySelectorAll(".hero-carousel__block-text-content")?.forEach((item) => {
            let contentLink = item.querySelector("a");
            contentLink.addEventListener("click", function (e) {
                window.dataLayer.push({
                    event: "ga4-event",
                    ga4_event_name: `hero-carousel-3-block--${screen}-content-${i + 1}`
                })
            })
        })
    })
}

let heroCarouselDesktop = document.querySelectorAll('.hero-carousel__body--desktop .hero-carousel__block');
let heroCarouselMobile = document.querySelectorAll('.hero-carousel__body--mobile .hero-carousel__block');
heroCarouselBlocks(heroCarouselDesktop, "desktop");
heroCarouselBlocks(heroCarouselMobile, "mobile");

// hero section two image two button slider
function heroTwoImageTwoButtonSlider(selector, screen) {
    selector.length && selector.forEach((hero, i) => {
        let heroSlide = hero.querySelectorAll(`.${screen}-content .${screen}-inner`);
        heroSlide?.forEach((slide, j) => {
            slide.addEventListener("click", function (e) {
                let slideIndex;

                if (screen === "mobile") slideIndex = i + 1;
                else if (screen === "desktop") slideIndex = j + 1;

                window.dataLayer.push({
                    event: "ga4-event",
                    ga4_event_name: `hero-slider-2-block--${screen}-${slideIndex}`
                })
            })
        });
    })
}

let twoImageTwoBtnSliderDesktop = document.querySelectorAll(".desktop-slider .hero-slider.two_img_cta");
let twoImageTwoBtnSliderMobile = document.querySelectorAll(".mobile-slider .hero-slider.two_img_cta");
heroTwoImageTwoButtonSlider(twoImageTwoBtnSliderDesktop, "desktop");
heroTwoImageTwoButtonSlider(twoImageTwoBtnSliderMobile, "mobile");

// hero section two image one button slider
function heroTwoImageOneButtonSlider(selector, screen) {
    selector.length && selector.forEach((hero) => {
        let heroSlide = hero.querySelectorAll(`.${screen}-content .${screen}-image`);
        heroSlide?.forEach((slide, i) => {
            slide?.addEventListener("click", function (e) {
                window.dataLayer.push({
                    event: "ga4-event",
                    ga4_event_name: `hero-slider-2-block-1-btn--${screen}-${i + 1}`
                })
            })
        });

        let heroSlideContent = hero?.querySelectorAll(".two-image-one-btn-content");
        heroSlideContent?.forEach((slide, i) => {
            let link = slide.querySelector("a");
            link.addEventListener("click", function (e) {
                window.dataLayer.push({
                    event: "ga4-event",
                    ga4_event_name: `hero-slider-2-block-1-btn--${screen}-button`
                })
            })
        });
    })
}

let twoImageSliderDesktop = document.querySelectorAll(".desktop-slider .hero-slider.two_img");
let twoImageSliderMobile = document.querySelectorAll(".mobile-slider .hero-slider.two_img");
heroTwoImageOneButtonSlider(twoImageSliderDesktop, "desktop")
heroTwoImageOneButtonSlider(twoImageSliderMobile, "mobile")

// hero section one image slider
function heroOneImageSlider(screen) {
    let oneImageSlider = document.querySelectorAll(".hero-slider.one_img");
    oneImageSlider.length && oneImageSlider.forEach((hero) => {
        hero?.addEventListener("click", function (e) {
            window.dataLayer.push({
                event: "ga4-event",
                ga4_event_name: `hero-slider-1-block--${screen}`
            })
        });
    })
}

// hero text media block slider
function heroTextMediaBlockSlider(selector, screen) {
    selector.length && selector.forEach((hero) => {
        let heroContentSlide = hero.querySelector(`.${screen}-content .${screen}-inner.contents`);
        let heroImageSlide = hero.querySelector(`.${screen}-content .${screen}-inner:not(.contents)`);

        heroImageSlide?.addEventListener("click", function (e) {
            window.dataLayer.push({
                event: "ga4-event",
                ga4_event_name: `hero-2-block--${screen}-image`
            })
        })
        heroContentSlide?.querySelector(`.content-slide .note-block`)?.addEventListener("click", function (e) {
            window.dataLayer.push({
                event: "ga4-event",
                ga4_event_name: `hero-2-block--${screen}-content`
            })
        })
        heroContentSlide?.querySelector(`.content-slide .button`)?.addEventListener("click", function (e) {
            window.dataLayer.push({
                event: "ga4-event",
                ga4_event_name: `hero-2-block--${screen}-button`
            })
        })
    })
}

let textMediaBlockSliderDesktop = document.querySelectorAll(".desktop-slider .hero-slider.text-media-slide");
let textMediaBlockSliderMobile = document.querySelectorAll(".mobile-slider .hero-slider.text-media-slide");
heroTextMediaBlockSlider(textMediaBlockSliderDesktop, "desktop");
heroTextMediaBlockSlider(textMediaBlockSliderMobile, "mobile");

// hero banner
function heroBanner(screen) {
    let banners = document.querySelectorAll('.shopify-section--banner .banner-section');
    banners.length && banners.forEach((banner) => {
        let content = banner.querySelector('.banner-section__content');
        content?.addEventListener("click", function (e) {
            window.dataLayer.push({
                event: "ga4-event",
                ga4_event_name: `hero-1-block--${screen}`
            })
        });
    })
}

// notification
function handleNotificationClick(screen) {
    window.dataLayer.push({
        event: "ga4-event",
        ga4_event_name: `notification-click--${screen}`
    });
}

function handleNotificationLinkClick(screen, i) {
    window.dataLayer.push({
        event: "ga4-event",
        ga4_event_name: `notification-link--${screen}-${i + 1}`
    });
}

function notificationHandler(screen) {
    const notificationLink = document.querySelectorAll(".header__notifications-link");
    const notifications = document.querySelectorAll(".notifications-list .notification");

    notificationLink.length && notificationLink.forEach((link) => {
        link.removeEventListener("click", link._clickHandler);
    });

    notificationLink.length && notificationLink.forEach((link) => {
        const boundHandler = handleNotificationClick.bind(null, screen);
        link._clickHandler = boundHandler;
        link.addEventListener("click", boundHandler);
    });

    notifications.length && notifications.forEach((notification) => {
        const anchor = notification.querySelector('a');
        if (anchor) {
            anchor.removeEventListener("click", anchor._clickHandler);
        }
    });

    notifications.length && notifications.forEach((notification, i) => {
        const anchor = notification.querySelector('a');
        if (anchor) {
            const boundHandler = handleNotificationLinkClick.bind(null, screen, i);
            anchor._clickHandler = boundHandler;
            anchor.addEventListener("click", boundHandler);
        }
    });
}

// global banner
function globalBannerHandler(screen) {
    let globalBanner = document.querySelector(".shopify-section-promo-bar");
    globalBanner?.addEventListener("click", function (e) {
        window.dataLayer.push({
            event: 'ga4-event',
            ga4_event_name: `global-banner--${screen}`
        })
    })
}

// VIT Points PDP Feature
function waitForElement(selector) {
    return new Promise((resolve) => {
        function checkElement() {
            const element = document.querySelector(selector);
            if (element) {
                resolve(element);
            } else {
                requestAnimationFrame(checkElement);
            }
        }
        checkElement();
    });
}

function VitPdpFeatureHandler(screen) {
    waitForElement("#yotpo-product-points-widget").then((VitPointsWidget) => {
        VitPointsWidget.addEventListener("click", function (e) {
            window.dataLayer.push({
                event: 'ga4-event',
                ga4_event_name: `pdp-vit-points-feature--${screen}`
            });
        });
    });
}

// PDP Explore The Collection
function PDPExploreCollection(screen) {
    const collections = document.querySelectorAll('.shopify-section--pdp-featured .featured-col__lists .slider .slide');

    if (!collections?.length) return;

    const addDataLayerEvent = (element, eventLabel, index) => {
        if (element) {
            element.addEventListener("click", (e) => {
                e.stopPropagation();
                window.dataLayer.push({
                    event: 'ga4-event',
                    ga4_event_name: `pdp-explore-collection-${eventLabel}--${screen}-${index + 1}`
                });
            });
        }
    };

    collections.forEach((collection, i) => {
        const elementsToTrack = {
            'product-card': collection,
            'image': collection.querySelector(".product-unit__image-wrapper .product-unit__image"),
            'quickview': collection.querySelector(".product-unit__image-wrapper .quick-view__link"),
            'button': collection.querySelector(".slider-info:not(.grow) .product-unit__button button")
        };

        for (const [label, element] of Object.entries(elementsToTrack)) {
            addDataLayerEvent(element, label, i);
        }
    });
}

function trackPdpPaymentButtons(screen) {
    const buttons = [
        { selector: ".template-product .pdp__submit shop-pay-wallet-button", section: "add_to_cart_pdp_shoppay" }
    ];

    const addDataLayerEvent = (element, section) => {
        if (element && !element.dataset.eventAttached) {
            element.addEventListener("click", () => {
                window.dataLayer.push({
                    event: 'ga4-event',
                    "ga4_event_name": `${section}--${screen}`
                });
            }, { once: true });

            element.dataset.eventAttached = true;
        }
    };

    buttons.forEach(({ selector, section }) => {
        const element = document.querySelector(selector);
        addDataLayerEvent(element, section);
    });
}

function trackCartPageButtons(screen) {
    const buttons = [
        { selector: ".template-cart shop-pay-wallet-button", section: "add_to_cart_cartpage_shoppay" },
        { selector: ".template-cart .button--checkout", section: "add_to_cart_cartpage_checkout" },
        { selector: ".template-cart shopify-paypal-button", section: "add_to_cart_cartpage_paypal" },
        { selector: ".template-cart shopify-google-pay-button", section: "add_to_cart_cart_googlepay" },
        { selector: ".template-cart shopify-apple-pay-button", section: "add_to_cart_cart_applepay" }
    ];

    const addDataLayerEvent = (element, section) => {
        if (element && !element.dataset.eventAttached) {
            element.addEventListener("click", () => {
                window.dataLayer.push({
                    event: 'ga4-event',
                    "ga4_event_name": `${section}--${screen}`
                });
            }, { once: true });

            element.dataset.eventAttached = true;
        }
    };

    buttons.forEach(({ selector, section }) => {
        const element = document.querySelector(selector);
        addDataLayerEvent(element, section);
    });
}

function trackPDPComparebtn(screen) {
    const comparebtn = document.querySelector("#mobile-compare-pd");
    if (comparebtn) {
        comparebtn.addEventListener("click", () => {
            window.dataLayer.push({
                event: 'ga4-event',
                "ga4_event_name": `pdp-compare-${screen}`
            });
        });
    }
}

let currentScreen = window.innerWidth < 900 ? 'mobile' : 'desktop';
notificationHandler(currentScreen);
heroBlocks(currentScreen);
heroBanner(currentScreen);
heroOneImageSlider(currentScreen);
globalBannerHandler(currentScreen);
VitPdpFeatureHandler(currentScreen);
PDPExploreCollection(currentScreen);
trackPdpPaymentButtons(currentScreen);
trackCartPageButtons(currentScreen);
trackPDPComparebtn(currentScreen);
